import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { FtCloudTelemetryState } from "./models/ft-cloud-telemetry-state";

@Injectable({
    providedIn: 'root'
})
export class StreamaxRawService {
    constructor(private readonly http: HttpClient) { }

    async getEndpointsStates(): Promise<FtCloudTelemetryState[]> {
        return await firstValueFrom(this.http.get<FtCloudTelemetryState[]>('/api/streamax-raw/endpoints'))
    }

    async toggleState(functionType: number): Promise<void> {
        await firstValueFrom(this.http.post(`/api/streamax-raw/toggle/${functionType}`, null))
    }
}